import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TradecreditorsSoletraderService {


  //  URL: any = 'https://localhost:44306/api/TradecreditorsSoletrader/';
  URL = this.ConfigService.getAPIBaseUrl() + 'api/TradecreditorsSoletrader/';
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveTradecreditorsSoletrader(data) {
    debugger;
    return this.HttpClient.post(this.URL + "InsertTradecreditorsSoletrader", data)
  } 
  GetOneTradecreditorsSoletrader(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetTradecreditorsSoletrader?APPeriodId=" + APPeriodId)
  }
}
